import { categories } from "@/mocks/home";

export default function Category() {
  return (
    <section id="category" className="relative w-full py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center">
          <span className="text-sm tracking-widest text-primary-400">CATEGORIES</span>
          <h2 className="mt-2 font-heading text-3xl text-foreground-50 md:text-4xl">主题分类</h2>
          <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-foreground-400">
            按类型快速定位心仪作品，从热血到治愈，总有一类契合你的口味。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 md:gap-6">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href="#top"
              className="group relative block overflow-hidden rounded-lg border border-background-800/70 bg-background-900 transition-colors hover:border-primary-500/60"
            >
              <div className="relative h-36 overflow-hidden md:h-40">
                <img
                  src={cat.image}
                  alt={`${cat.name}动漫分类`}
                  title={`${cat.name}动漫分类`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/85 to-background-950/10" />
                <span className="absolute right-3 top-3 flex h-9 w-9 items-center justify-center rounded-md bg-background-950/70 text-primary-300">
                  <i className={cat.icon} />
                </span>
              </div>
              <div className="p-4">
                <div className="flex items-center justify-between">
                  <h3 className="font-heading text-lg text-foreground-50">{cat.name}</h3>
                  <span className="text-xs text-accent-400">{cat.count}</span>
                </div>
                <p className="mt-0.5 text-[11px] tracking-wider text-foreground-500">{cat.en}</p>
                <p className="mt-2 text-xs leading-relaxed text-foreground-400">{cat.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}